const defaultOptions = {
  withCredentials: false,
  requestInterceptors: [],
  responseInterceptors: [],
  jsonp: false,
  success: () => {},
  error: () => {}
};

export function setDefaultOptions(options) {
  Object.assign(defaultOptions, options);
}

export function extendOptions(options = {}, extension = {}) {
  if ('withCredentials' in extension) {
    options.withCredentials = extension.withCredentials;
  }

  if ('jsonp' in extension) {
    options.jsonp = extension.jsonp;
  }

  if ('success' in extension) {
    options.success = extension.success;
  }
  if ('error' in extension) {
    options.error = extension.error;
  }
  if ('requestInterceptors' in extension && Array.isArray(extension.requestInterceptors)) {
    options.requestInterceptors = [
      ...(options.requestInterceptors || []),
      ...extension.requestInterceptors
    ];
  }
  if ('responseInterceptors' in extension && Array.isArray(extension.responseInterceptors)) {
    options.responseInterceptors = [
      ...(options.responseInterceptors || []),
      ...extension.responseInterceptors
    ];
  }
}

export default defaultOptions;
